import { isNumber, isObject } from "../utils/utils"

export function getRetryInterceptor() {
    const maxAttempts = 10

    return [
        "$injector",
        "$q",
        "$timeout",
        function ($injector: any, $q: ng.IQService, $timeout: ng.ITimeoutService) {
            return {
                responseError: (response: ng.IHttpResponse<any>) => {
                    //409 conflict
                    //429 too many requests
                    //502 bad gateway (gateway cannot connect to backend pool - ie. 503 app service/omnia)
                    //503 service unavailable (application gateway is down)
                    //504 gateway timeout (gateway did not get response from app service/omnia within timout setting set in backend settings)
                    if ([409, 429, 502, 503, 504].includes(response.status)) {
                        const omnia = response.config["_omnia"] as { attempt: number }

                        if (
                            shouldRetryRequest(response) &&
                            isObject(omnia) &&
                            isNumber(omnia.attempt) &&
                            omnia.attempt < maxAttempts
                        ) {
                            const attempt = omnia.attempt++

                            const delay = Math.min(1000, attempt * 1000)

                            console.log(
                                `http: retrying, url=${response.config.url}, attempt=${attempt + 1}, delay=${delay}`
                            )

                            return $timeout(delay).then(() => {
                                const $http = $injector.get("$http")
                                return $http(response.config)
                            })
                        }
                    }

                    return $q.reject(response)
                },
            }
        },
    ]
}

function shouldRetryRequest(response: ng.IHttpResponse<any>) {
    const r = response.headers("X-Omnia-Retry")

    return r === undefined ? true : r != "No"
}
